import { render } from "./Servicios.vue?vue&type=template&id=64f36fae&scoped=true"
const script = {}

import "./Servicios.vue?vue&type=style&index=0&id=64f36fae&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f36fae"]])

export default __exports__